<div class="innerBanner">
    <div class="container md">
        <div class="userCoures">
            <div class="row">
                <div class="col-12 col-md-7">
                    <div class="userCouresLatest">
                        <span class="userCouresImage" style="background: url(assets/images/demo.png);"></span>
                        <div class="userCouresContent">
                            <h3>{{assignDetailResume.course_name}}</h3>
                            <p><span *ngIf="assignDetailResume.module_count <= 1">{{assignDetailResume.module_count}}
                                    Module</span>
                                <span *ngIf="assignDetailResume.module_count > 1">{{assignDetailResume.module_count}}
                                    Modules</span>
                                <span
                                    *ngIf="assignDetailResume.submodule_count <= 1">{{assignDetailResume.submodule_count}}
                                    Sub Module</span>
                                <span
                                    *ngIf="assignDetailResume.submodule_count > 1">{{assignDetailResume.submodule_count}}
                                    Sub Modules</span>
                            </p>
                            <p>
                                <span>{{assignDetailResume.course_desc}}</span>
                            </p>
                            <p class="mt-2"><span>Assigned on
                                    {{assignDetailResumePro.assigned_date}}</span><span>Last Viewed on
                                    {{assignDetailResumePro.last_submodule_seen_time}}</span></p>
                            <!-- <div class="resumWrap mt-2">
                                <div class="moduelWrap">
                                    <button class="btn btn-primary"
                                        (click)="downloadCartiCourse(assignDetailResume.course_name,assignDetailResumeUserCourse.course_completed_dttm)">Download
                                        Certificate</button>
                                </div>
                            </div> -->
                        </div>

                    </div>
                </div>
                <div class="col-12 col-md-5">
                    <div class="" (click)="showDetailsEvent()"
                        [ngClass]="showDetails ? 'mobileShowView active' : 'mobileShowView'">View Full Details</div>
                        <div class="resumWrap mt-2">
                            <div class="moduelWrap">
                                <button class="btn btn-primary"
                                    (click)="downloadCartiCourse(assignDetailResume.course_name,assignDetailResumeUserCourse.course_completed_dttm)">Download
                                    Certificate</button>
                            </div>
                        </div>
                    <ul class="row" [ngClass]="showDetails ? 'mobileViews active' : 'mobileViews'">
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/durationIcon.svg">
                                </span>
                                <div class="joinerContent">
                                    <h3>40 Hr</h3>
                                    <p>Course Duration</p>
                                </div>
                            </div>
                        </li>
                        
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/clock.svg">
                                </span>
                                <div class="joinerContent">
                                    <h3 *ngIf="assignDetailResumeUserCourse.total_time_spent">
                                        {{secondsToHms(assignDetailResumeUserCourse.total_time_spent)}}</h3>
                                    <p>Time spent on course</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/doughnut_chart.svg">
                                </span>
                                <div class="joinerContent">
                                    <h3>100%</h3>
                                    <p>Course completed</p>
                                </div>
                            </div>
                        </li>
                        
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/book.svg">
                                </span>
                                <div class="joinerContent">
                                    <h3>{{assignDetailResume.module_count}} modules</h3>
                                    <p>Completed</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/assessments.svg">
                                </span>
                                <div class="joinerContent">
                                    <h3>{{assignDetailResumePro.total_assessments_count}} /
                                        {{assignDetailResumePro.total_assessments_count}} Assessments</h3>
                                    <p>Cleared</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/time.svg">
                                </span>
                                <div class="joinerContent">
                                    <h3>{{assignDetailResumeUserCourse.avg_assessment_time}}</h3>
                                    <p>Spent on assessment</p>
                                </div>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="tabsWrap">
    <div class="container md">
        <mat-tab-group animationDuration="0ms" [selectedIndex]="activeTab">
            <mat-tab *ngFor="let values of assignDetailResume.modules; let i = index">

                <ng-template mat-tab-label>
                    <b>Module {{i+1}}:</b>{{values.module_name}}
                </ng-template>
                <div class="contentBody">
                    <div class="pl-4 mt-4 pr-4">
                        <div class="moduleHead">
                            <div class="mudleSubHead">
                                <h3><b>Module {{i+1}}:</b>{{values.module_name}}</h3>
                                <!-- <ul class="modifyIcons">
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                </li>
                            </ul> -->
                            </div>
                        </div>
                        <p>{{values.module_desc}}</p>

                        <p class="assignOn text-left mt-2 mb-2"><span>Start Date:
                                {{values.started_dttm}}</span><span>Last Viewed: {{values.last_viewed_dttm}}</span></p>
                        <div class="row m-0">
                            <div class="grapgReaWrap">
                                <ul>
                                    <li>
                                        <div class="joinerDetails mb-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/durationIcon.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3>40 Hr</h3>
                                                <p>Course Duration</p>
                                            </div>

                                        </div>
                                    </li>
                                    <li>
                                        <div class="joinerDetails mb-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/doughnut_chart.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3>100 %</h3>
                                                <p>completed</p>
                                                <!-- <div class="ghrapWrap">
                                                    <span style="width: 100%;"></span>
                                                </div> -->
                                            </div>

                                        </div>
                                    </li>
                                    <li>
                                        <div class="joinerDetails mb-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/clock.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3 *ngIf="values.time_spent">{{secondsToHms(values.time_spent)}}</h3>
                                                <p>Spent on course</p>
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div class="joinerDetails">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/time.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3>{{values.module_assessment_time_spent}} min</h3>
                                                <p>assessment avg. time</p>
                                            </div>
                                        </div>
                                    </li>

                                    <li>
                                        <div class="joinerDetails">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/gps.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3>{{values.assessment_attempt_num}} / 3</h3>
                                                <p>No. of Attempts</p>
                                            </div>
                                            <p class="failedContent d-none">3 Attempts failed previously</p>
                                        </div>
                                    </li>
                                    <li class="assessMent">
                                        <a href="" class="greenBtn pointer-none"><b><img src="assets/images/icons/w_tick.svg">
                                                    </b> Assessment Passed </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="submudleWrap">
                        <mat-accordion>
                            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                                *ngFor="let subValues of values.sub_modules; let j = index">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <div class="moduleHead">
                                            <div class="submudleHead">
                                                <h3> <b>SUB MODULE {{j+1}}:</b>{{subValues.submodule_name}}</h3>
                                                <div class="viewpass">
                                                    <a href="javascript:void(0);" class="btn-link text-uppercase"
                                                        [routerLink]="['/viewer']"
                                                        [queryParams]="{modId:values.module_id,subModlId:subValues.submodule_id,courseId:courseId,view:2}">View</a>
                                                    <a href="javascript:void(0);" class="btn-link-green text-uppercase"
                                                        *ngIf="!subValues.assessment_id">Completed</a>
                                                    <a class="btn-link-green text-uppercase"
                                                        *ngIf="subValues.assessment_id">Passed</a>
                                                </div>
                                                <ul class="modifyIcons">

                                                    <li *ngIf="subValues.media_type[0]==1"><a
                                                            ><img
                                                                src="assets/images/icons/text.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[1]==1"><a
                                                            ><img
                                                                src="assets/images/icons/text.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[2]==1"><a
                                                           ><img
                                                                src="assets/images/icons/text.svg"></a></li>

                                                    <li *ngIf="subValues.media_type[0]==2"><a
                                                            ><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[1]==2"><a
                                                           ><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[2]==2"><a
                                                           ><img
                                                                src="assets/images/icons/insert-picture.svg"></a></li>

                                                    <li *ngIf="subValues.media_type[0]==3"><a
                                                           ><img
                                                                src="assets/images/icons/video-camera.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[1]==3"><a
                                                           ><img
                                                                src="assets/images/icons/video-camera.svg"></a></li>
                                                    <li *ngIf="subValues.media_type[2]==3"><a
                                                          ><img
                                                                src="assets/images/icons/video-camera.svg"></a></li>
                                                    <li *ngIf="subValues.assessment_id"><a
                                                           ><img
                                                                src="assets/images/icons/frame.svg"></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>{{subValues.submodule_desc}}</p>
                                <p class="assignOn text-left"><span>Start Date:
                                        {{subValues.start_date}}</span><span>Last Viewed:
                                        {{subValues.last_viewed_dttm}}</span></p>
                                <div class="row m-0">
                                    <div class="col-12 col-md-3">
                                        <div class="joinerDetails mb-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/doughnut_chart.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3>{{subValues.percent_complete}}%</h3>
                                                <p>Submodule completed</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-3">
                                        <div class="joinerDetails mb-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/clock.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3 *ngIf="subValues.total_time_spent">
                                                    {{secondsToHms(subValues.total_time_spent)}}</h3>
                                                <h3 *ngIf="!subValues.total_time_spent">0 hr 0 min</h3>
                                                <p>Time spent on submodule</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-3" *ngIf="subValues.assessment_id">
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/time.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3 *ngIf="subValues.assessment_time_spent">
                                                    {{subValues.assessment_time_spent}}</h3>
                                                <h3 *ngIf="!subValues.assessment_time_spent">0 hr 0 min</h3>
                                                <p>Spent on assessment</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-3" *ngIf="subValues.assessment_id">
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/gps.svg">
                                            </span>
                                            <div class="joinerContent">
                                                <h3>{{subValues.assessment_attempt_num}}/3</h3>
                                                <p>No. of Attempts</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <input type="hidden" (click)="open1(multiloginValidation)" id="successMsg">
</div>
<ng-template #multiloginValidation let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="navigationEvent();modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">Please logout from other devices or login again to continue using the portal here</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="navigationEvent();modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>